import React from "react";

function Ellipsis() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M7.33331 3.75C7.33331 3.55222 7.39196 3.35888 7.50184 3.19443C7.61173 3.02998 7.7679 2.90181 7.95063 2.82612C8.13336 2.75043 8.33442 2.73063 8.5284 2.76922C8.72239 2.8078 8.90057 2.90304 9.04042 3.04289C9.18027 3.18275 9.27551 3.36093 9.3141 3.55491C9.35268 3.74889 9.33288 3.94996 9.25719 4.13268C9.18151 4.31541 9.05333 4.47159 8.88888 4.58147C8.72444 4.69135 8.5311 4.75 8.33331 4.75C8.0681 4.75 7.81374 4.64464 7.62621 4.45711C7.43867 4.26957 7.33331 4.01522 7.33331 3.75ZM8.33331 7C8.13553 7 7.94219 7.05865 7.77774 7.16853C7.61329 7.27841 7.48512 7.43459 7.40943 7.61732C7.33375 7.80004 7.31394 8.00111 7.35253 8.19509C7.39111 8.38907 7.48635 8.56725 7.62621 8.70711C7.76606 8.84696 7.94424 8.9422 8.13822 8.98078C8.3322 9.01937 8.53327 8.99957 8.716 8.92388C8.89872 8.84819 9.0549 8.72002 9.16478 8.55557C9.27466 8.39112 9.33331 8.19778 9.33331 8C9.33331 7.73478 9.22796 7.48043 9.04042 7.29289C8.85288 7.10536 8.59853 7 8.33331 7ZM8.33331 11.25C8.13553 11.25 7.94219 11.3086 7.77774 11.4185C7.61329 11.5284 7.48512 11.6846 7.40943 11.8673C7.33375 12.05 7.31394 12.2511 7.35253 12.4451C7.39111 12.6391 7.48635 12.8173 7.62621 12.9571C7.76606 13.097 7.94424 13.1922 8.13822 13.2308C8.3322 13.2694 8.53327 13.2496 8.716 13.1739C8.89872 13.0982 9.0549 12.97 9.16478 12.8056C9.27466 12.6411 9.33331 12.4478 9.33331 12.25C9.33331 11.9848 9.22796 11.7304 9.04042 11.5429C8.85288 11.3554 8.59853 11.25 8.33331 11.25Z"
        fill="#3A383F"
      />
    </svg>
  );
}

export default Ellipsis;
